import React, { useEffect, useState } from "react";
import { BuilderStarSvg, InformationSvg } from "assets/images/svgs";
import AssessmentOne from "assets/images/others/attendee-side-images/assessment-1.png";
import AssessmentCompleted from "assets/images/others/attendee-side-images/AssessmentComplete.png";
import AcknowledgedPopup from "./AcknowledgedPopup";
import { useNavigate, useSearchParams } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import useAttendee from "containers/attendee/useHooks";
import { MinorDTO } from "utils/helpers/models/attendee/minor.dto";
import DataNotFound from "components/data-not-found";
import { useSelector } from "react-redux";

type TabType = "analysis" | "summary" | "tips";
interface TabItem {
  id: TabType;
  label: string;
}


const Assessment = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");



  const { getAssessmentSummaryById, getAssessmentCoreConceptsById, getMinorById } =
    useAttendee();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  const [minor, setMinor] = useState<MinorDTO>(() => {
    const savedMinor = localStorage.getItem("minorProfile");
    return savedMinor ? new MinorDTO(JSON.parse(savedMinor)) : new MinorDTO();
  });
  const [minorData, setMinorData] = useState<MinorDTO>(new MinorDTO());
  const [assessmentSummaryData, setAssessmentSummaryData] = useState<any>(null);
  const [assessmentCoreConceptsData, setAssessmentCoreConceptsData] =
    useState<any>(null);
  const [acknowledgedModalOpen, setAcknowledgedModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<TabType>("analysis");

  console.log(assessmentSummaryData);
  



  const tabs: TabItem[] = [
    { id: "analysis", label: "Concept Analysis" },
    { id: "summary", label: "Summary" },
    { id: "tips", label: "Recommended" },
  ];

  const closeModals = () => {
    setAcknowledgedModalOpen(false);
  };

  useEffect(() => {
    if (id) {
      getMinorById((Number(id)), setMinorData);
    }
  }, []);

  console.log(minorData, 'data');


  useEffect(() => {
    if (
      minorData?.isLearningAssessment === true &&
      minorData?.isCoreConceptAssessment === true &&
      minorData?.id
    ) {
      getAssessmentSummaryById(minorData?.id, setAssessmentSummaryData);
      getAssessmentCoreConceptsById(minorData?.id, setAssessmentCoreConceptsData);
    }
  }, [minorData?.isLearningAssessment]);

  const goToLearningQuestions = () => {
    const savedMinor = localStorage.getItem("minorProfile");
    const currentMinor = savedMinor
      ? new MinorDTO(JSON.parse(savedMinor))
      : null;

    if (currentMinor?.isLearningAssessment === false) {
      navigate(siteRoutes.familyDetailAssessment);
    } else if (currentMinor?.isLearningAssessment === true) {
      navigate(siteRoutes.assessmentLearningSkills);
    }
  };

  console.log(minor, 'minor');



  return (
    <div className="min-h-[80vh]">
      {minorData?.isLearningAssessment === true &&
        minorData?.isCoreConceptAssessment === true ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 ">
          <div>
            <div className="flex flex-col">
              <h1 className="text-3xl font-semibold text-blackie">
                Assessment Completed
              </h1>

              <p className="text-lightBlackText text-lg mt-3 mb-4">
                Emphasizes early-stage development across social, emotional,
                cognitive, and motor domains
              </p>
            </div>

            {/* Tab Navigation */}
            <div className="flex mb-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`text-base px-4 pb-1 transition-colors duration-300 ${activeTab === tab.id
                    ? "text-lightBlueColor font-medium border-b-2 border-lightBlueColor"
                    : "text-grayText font-semibold hover:text-lightBlueColor"
                    }`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="tab-content">
              {activeTab === "analysis" ? (
                <div>
                  <div className="grid grid-cols-2 gap-4 mt-6">
                    <div className="bg-fade p-3 rounded-lg">
                      <h1 className="text-blackie text-sm  font-medium">
                        Explorer
                      </h1>
                      <ul className="list-none text-xs text-lightBlackText">
                        {assessmentCoreConceptsData?.coreConcepts &&
                          assessmentCoreConceptsData.coreConcepts.filter(
                            (concept: any) =>
                              concept.averagePoints >= 1 &&
                              concept.averagePoints <= 2
                          ).length > 0 ? (
                          assessmentCoreConceptsData.coreConcepts
                            .filter(
                              (concept: any) =>
                                concept.averagePoints >= 1 &&
                                concept.averagePoints <= 2
                            )
                            .map((concept: any, idx: number) => (
                              <li key={idx} className="mb-1">
                                <span>– {concept?.name}</span>
                              </li>
                            ))
                        ) : (
                          <li className="text-center text-gray-500 py-4">
                            No core concept found
                          </li>
                        )}
                      </ul>
                    </div>
                    <div className="bg-fade p-3 rounded-lg">
                      <h1 className="text-blackie text-sm  font-medium">
                        Builder
                      </h1>
                      <ul className="list-none text-xs text-lightBlackText">
                        {assessmentCoreConceptsData?.coreConcepts &&
                          assessmentCoreConceptsData.coreConcepts.filter(
                            (concept: any) =>
                              concept.averagePoints >= 2 &&
                              concept.averagePoints < 3
                          ).length > 0 ? (
                          assessmentCoreConceptsData.coreConcepts
                            .filter(
                              (concept: any) =>
                                concept.averagePoints >= 2 &&
                                concept.averagePoints < 3
                            )
                            .map((concept: any, idx: number) => (
                              <li key={idx} className="mb-1">
                                <span>– {concept?.name}</span>
                              </li>
                            ))
                        ) : (
                          <li className="text-center text-gray-500 py-4">
                            No core concept found
                          </li>
                        )}
                      </ul>
                    </div>
                    <div className="bg-fade p-3 rounded-lg">
                      <h1 className="text-blackie text-sm  font-medium">
                        Innovator
                      </h1>
                      <ul className="list-none text-xs text-lightBlackText">
                        {assessmentCoreConceptsData?.coreConcepts &&
                          assessmentCoreConceptsData.coreConcepts.filter(
                            (concept: any) => concept.averagePoints >= 3
                          ).length > 0 ? (
                          assessmentCoreConceptsData.coreConcepts
                            .filter(
                              (concept: any) => concept.averagePoints >= 3
                            )
                            .map((concept: any, idx: number) => (
                              <li key={idx} className="mb-1">
                                <span>– {concept?.name}</span>
                              </li>
                            ))
                        ) : (
                          <li className="text-center text-gray-500 py-4">
                            No core concept found
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              ) : activeTab === "summary" ? (
                <div>
                  <div className="flex items-center gap-4 mb-4">
                    <div>
                      <BuilderStarSvg />
                    </div>
                    <div className="flex flex-col gap-2">
                      <span className="text-blackie">
                        {assessmentSummaryData?.levelTitle}
                      </span>
                      <span className="text-sm text-blackie">
                        {assessmentSummaryData?.totalPoints} points
                      </span>
                    </div>
                  </div>

                  <p className="text-lightBlackText mb-4">
                    {assessmentSummaryData?.levelDescription}
                  </p>

                  <div className="grid grid-cols-2 gap-4">
                    {assessmentSummaryData?.summary?.map(
                      (item: any, index: number) => (
                        <div
                          key={index}
                          className="p-4 rounded relative"
                          style={{ backgroundColor: item?.category?.color }}
                        >
                          <div>
                            <h3 className="text-lg text-white font-semibold">
                              {item?.category?.name}
                            </h3>

                            <ul className="list-none text-white">
                              {item?.coreConcepts?.map(
                                (concept: any, idx: number) => (
                                  <li key={idx} className="mb-1">
                                    <span className="font-medium">
                                      – {concept?.name}
                                    </span>{" "}
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              ) : (
                <div className="flex flex-col gap-4">
                  <div className="shadow-sm p-4">
                    <h2 className="text-base font-semibold text-blackie mb-4">
                      Focus Areas for Growth
                    </h2>
                    {assessmentCoreConceptsData?.coreConcepts &&
                      assessmentCoreConceptsData.coreConcepts
                        .filter((concept: any) => concept.averagePoints > 1)
                        .slice(0, 3)
                        .map((concept: any, idx: number) => (
                          <div
                            className="flex justify-between items-center mb-2"
                            key={idx}
                          >
                            <span className="text-blackie text-sm font-medium">
                              {concept?.name}
                            </span>
                            <span className="bg-fade w-fit text-blackie px-2 py-2 rounded text-xs font-medium">
                              {concept.averagePoints > 1 &&
                                concept.averagePoints <= 1.5
                                ? "Needs Practice"
                                : concept.averagePoints > 1.5
                                  ? "Developing"
                                  : null}
                            </span>
                          </div>
                        ))}
                  </div>

                  <div className="shadow-sm p-4">
                    <h2 className="text-base font-semibold text-blackie mb-4">
                      Suggested Experience Types
                    </h2>
                    <ul className="list-disc text-xs text-lightBlackText">
                      {assessmentCoreConceptsData?.coreConcepts
                        ?.slice(0, 10)
                        .map((concept: any, idx: number) => (
                          <li key={idx} className="mb-1">
                            <span>{concept?.description}</span>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
            <div className="mt-10">
              <DataNotFound show={!isLoading && !assessmentSummaryData} />
            </div>
          </div>
          <div>
            <img src={AssessmentCompleted} alt="Assessment" />
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          <div className="flex flex-col gap-4 mt-12">
            <div className="flex justify-between items-center pb-4">
              <h1 className="text-3xl font-semibold text-blackie">
                Instructions
              </h1>
              <span
                onClick={() => setAcknowledgedModalOpen(true)}
                className="w-8 h-8 cursor-pointer"
              >
                <InformationSvg />
              </span>
            </div>

            <div className="space-y-3 mb-4">
              <h2 className="text-xl font-medium text-blackie">
                About Experience
              </h2>
              <p className="text-lightBlackText text-lg">
                For each statement, choose the response that best describes your
                child...
              </p>
            </div>

            <div className="space-y-3">
              <h2 className="text-xl font-medium text-blackie">
                Grading System
              </h2>
              <ul className="list-none text-lightBlackText flex gap-3">
                <li className="flex flex-col items-center justify-center bg-fade py-2 px-4 rounded h-[52px]">
                  <span className="text-sm text-blackie font-medium">
                    Often
                  </span>
                  <span className="text-sm text-lightBlackText">3 Point</span>
                </li>
                <li className="flex flex-col items-center justify-center bg-fade py-2 px-4 rounded h-[52px]">
                  <span className="text-sm text-blackie font-medium">
                    Sometimes
                  </span>
                  <span className="text-sm text-lightBlackText">2 Point</span>
                </li>
                <li className="flex flex-col items-center justify-center bg-fade py-2 px-4 rounded h-[52px]">
                  <span className="text-sm text-blackie font-medium">
                    Rarely
                  </span>
                  <span className="text-sm text-lightBlackText">1 Point</span>
                </li>
              </ul>
            </div>

            <button
              onClick={goToLearningQuestions}
              className="px-5 py-3 bg-primaryBlueBg text-white w-fit rounded-full mt-4 md:mt-12"
            >
              Start Assessment
            </button>
          </div>
          <div>
            <img src={AssessmentOne} alt="Assessment" />
          </div>
        </div>
      )}

      {acknowledgedModalOpen && (
        <AcknowledgedPopup
          isOpen={acknowledgedModalOpen}
          onClose={closeModals}
        />
      )}
    </div>
  );
};

export default Assessment;
